import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      class: "dialog-open-btn",
      color: "primary",
      onClick: _ctx.openDialog
    }, {
      default: _withCtx(() => [
        _createTextVNode("Új szálláshely")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialog) = $event)),
      width: "800",
      persistent: true,
      "no-click-animation": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "create-card",
          title: "Új szálláshely"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.v$.name.$model,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
                          "error-messages": _ctx.v$.name.$errors.map(error => error.$message),
                          label: "Szálláshely neve",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "error-messages"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.v$.city.$model,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.city.$model) = $event)),
                          "error-messages": _ctx.v$.city.$errors.map(error => error.$message),
                          label: "Város",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "error-messages"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.v$.address.$model,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.address.$model) = $event)),
                          "error-messages": _ctx.v$.address.$errors.map(error => error.$message),
                          label: "Cím",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "error-messages"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.v$.billingAddress.$model,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.billingAddress.$model) = $event)),
                          "error-messages": _ctx.v$.billingAddress.$errors.map(error => error.$message),
                          label: "Számlázási cím",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "error-messages"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.v$.phoneNumber.$model,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.phoneNumber.$model) = $event)),
                          "error-messages": _ctx.v$.phoneNumber.$errors.map(error => error.$message),
                          label: "Telefonszám",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "error-messages"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.v$.email.$model,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
                          "error-messages": _ctx.v$.email.$errors.map(error => error.$message),
                          label: "E-mail",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "error-messages"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "button-row" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, { onClick: _ctx.submitAccommodation }, {
                      default: _withCtx(() => [
                        _createTextVNode("Szálláshely hozzáadása")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, { onClick: _ctx.closeDialog }, {
                      default: _withCtx(() => [
                        _createTextVNode("Vissza")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}